<template>
  <v-menu max-width="500" bottom left v-if="show">
    <template v-slot:activator="{ on }">
      <v-btn icon dark v-on="on">
        <v-badge right overlap color="error" v-if="notificationItems.length > 0" :content="notificationItems.length">
          <v-icon v-text="$vuetify.icons.values.reminder" />
        </v-badge>
      </v-btn>
    </template>
    <v-card class="pa-1">
      <perfect-scrollbar :options="{ suppressScrollX: true }">
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="12" v-for="(item, index) in notificationItems" :key="index">
              <component :is="item.component" />
            </v-col>
          </v-row>
        </v-card-text>
      </perfect-scrollbar>
    </v-card>
  </v-menu>
</template>

<script>
import { isEmpty } from 'lodash/lang'
import { mapState, mapActions, mapGetters } from 'vuex'
import { NAMESPACE } from '../store'

export default {
  name: 'NotificationHeaderItem',
  computed: {
    ...mapState(NAMESPACE, ['notificationItems']),
    show() {
      return !isEmpty(this.notificationItems)
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .v-card__text {
  padding: 0 !important;
  max-height: 300px;
  max-width: 400px;
  -webkit-overflow-scrolling: touch;
}

::v-deep .v-badge__badge {
  font-size: 10px;
  height: 18px;
  width: 18px;
}
</style>
